import PropTypes from 'prop-types';
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { Button } from 'components/Button';

const ControlledSubmitButton = ({
	name = 'submit', children, disabled, buttonStyleVariant
}) => {

	const { formState } = useFormContext();

	return (
		<Controller
			as={Button}
			name={name}
			type="submit"
			loading={formState.isSubmitting}
			aria-disabled={formState.isSubmitting || disabled}
			buttonStyleVariant={buttonStyleVariant}
		>
			{children || name}
		</Controller>
	);

};

ControlledSubmitButton.propTypes = {
	name: PropTypes.string,
	children: PropTypes.node,
	disabled: PropTypes.bool,
	buttonStyleVariant: PropTypes.string
};

export default ControlledSubmitButton;
